import {SessionInfoStateType} from 'module/SessionInfo/reducer/SessionInfoReducer';

export const selCurrentUser = (state: SessionInfoStateType) => state.SessionInfo.data?.evoAppsUser;

export const selCurrentUsername = (state: SessionInfoStateType) => state.SessionInfo.data?.evoAppsUser?.username
export const selCurrentUsernameLong = (state: SessionInfoStateType) => state.SessionInfo.data?.evoAppsUser?.longUsername
export const selCurrentUserIsAlternative = (state: SessionInfoStateType) => !!state.SessionInfo.data?.evoAppsUser?.alternativeUser
export const selCurrentUserPersNr = (state: SessionInfoStateType) => state.SessionInfo.data?.evoAppsUser?.persNr
export const selCurrentUserlevel = (state: SessionInfoStateType) => Number(state.SessionInfo.data?.evoAppsUser?.userGroup?.userLevel)

export const selSessionInfoData = (state: SessionInfoStateType) => state.SessionInfo.data
export const selSessionInfoExpanded = (state: SessionInfoStateType) => state.SessionInfo.expanded